export const isImage = (type: string) => type.startsWith('image/');

export const isVideo = (type: string) => type.startsWith('video/');

export const isAudio = (type: string) => type.startsWith('audio/');

export const isPdf = (type: string, pdfSrc?: string): pdfSrc is string =>
    type === 'application/pdf' && pdfSrc !== undefined;
